import api from './axiosInstance';

export const DOCUMENT_PREVIEW_EVENT = 'ca-document-preview';
const root = `${process.env.REACT_APP_API_URL}/Documents`;

export async function loadDocumentPdf(path) {
  try {
    return (await api.get(`${root}/${path}`, { responseType: 'blob' })).data;
  } catch (error) {
    const body = error?.raw?.response?.data ?? error?.response?.data;
    if (body instanceof Blob) {
      const text = await body.text();
      try { const data = JSON.parse(text); throw new Error(data.error || data.message || data.title || 'Unable to load document.'); }
      catch (parsed) { if (!(parsed instanceof SyntaxError)) throw parsed; }
    }
    throw new Error(error?.message || 'Unable to load document.');
  }
}

// Callers pass a read-only loader. A configured-printer action, when available, is separate.
export function previewDocument(load, { title = 'Document preview', filename = 'Document.pdf', queuePrint } = {}) {
  window.dispatchEvent(new CustomEvent(DOCUMENT_PREVIEW_EVENT, { detail: { load, title, filename, queuePrint } }));
}

export function previewSavedDocument(path, options) {
  previewDocument(() => loadDocumentPdf(path), options);
}

export async function assertPdf(blob) {
  if (!(blob instanceof Blob) || blob.size === 0) throw new Error('The document is empty.');
  const signature = await blob.slice(0, 5).text();
  if (signature !== '%PDF-') throw new Error('The server did not return a PDF document.');
  return blob;
}

export function downloadPdf(url, filename) {
  const link = document.createElement('a');
  link.href = url; link.download = filename.replace(/[<>:"/\\|?*]/g, '_').split('').map(c => c.charCodeAt(0) < 32 ? '_' : c).join('');
  document.body.appendChild(link); link.click(); link.remove();
}
